import myzod, { Infer } from 'myzod'
import { JobAuctionEntitySchema } from '../../entities/app/auction/jobAuction'

export const JobAuctionEventSchema = JobAuctionEntitySchema.and(
  myzod.object({ awardTo: myzod.string().pattern(/^User/).optional() }),
)

export type JobAuctionEvent = Infer<typeof JobAuctionEventSchema>
